import axios from 'axios';
import connection from './connection';
import { QcClearanceDTO, QCClearanceResponseModel } from '@gtpl/shared-models/planning';
import { CommonResponse } from '@gtpl/shared-models/masters';



export class QCClearanceInfoService {
  URL = connection.DEPLOY_URL + '/qc-clearance-info';

  async createClearance(req: any): Promise<QCClearanceResponseModel> {
    return await axios.post(this.URL + '/createClearance', req).then((res) => {
        return res.data;
      });
  }

  async getFileDetailsById(req: QcClearanceDTO): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getFileDetailsById', req).then((res) => {
        return res.data;
      });
  }
}